var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.1,
    height: 15.508,
    viewBox: "0 0 12.1 15.508",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#c4c6c7;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-32.029)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M40.345,2.357A3.012,3.012,0,0,0,41.215,0a3.933,3.933,0,0,0-2.463,1.118A2.884,2.884,0,0,0,37.864,3.4,3.279,3.279,0,0,0,40.345,2.357Zm1.79,5.973a3.474,3.474,0,0,1,1.6-2.915A3.434,3.434,0,0,0,41.022,3.9c-1.158-.122-2.258.7-2.845.7s-1.491-.685-2.451-.667a3.622,3.622,0,0,0-3.074,1.921c-1.311,2.344-.336,5.816.942,7.717.625.931,1.368,1.975,2.345,1.937.943-.038,1.3-.627,2.436-.627s1.457.627,2.452.608c1.013-.019,1.654-.949,2.274-1.882a8.558,8.558,0,0,0,1.029-2.177A3.374,3.374,0,0,1,42.135,8.33Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.14667328.svg";
export { ForwardRef as ReactComponent };